import { TweenConstants } from "@lib/titan2-slingo/dist/game/view/abstract/constant/TweenConstants";
import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { MouseBlocker } from "@lib/titan2/dist/game/control/MouseBlocker";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { ScatterPickEvent } from "../../../controller/event/GameEvent";
import { GameMathUtil } from "../../../utils/GameMathUtil";
export class GameScatterPickBackground extends AbstractGameView {
    create() {
        super.create();
        Logger.addObjectRef(this);
        this.mouseBlocker = new MouseBlocker(this.landscapeProperties.mouseBlockerProperties, this.portraitProperties?.mouseBlockerProperties);
        this.addChild(this.mouseBlocker);
        this.backgroundSpine = TitanSpine.createSpine(this, this.landscapeProperties.backgroundSpineProperties, this.portraitProperties?.backgroundSpineProperties);
        this.titleSpine = TitanSpine.createSpine(this, this.landscapeProperties.titleSpineProperties, this.portraitProperties?.titleSpineProperties);
        this.instructionsText = TitanText.createField(this, this.landscapeProperties.instructionsProperties, this.portraitProperties?.instructionsProperties);
    }
    postCreate() {
        super.postCreate();
        this.visible = false;
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(ScatterPickEvent.TRANSITION_IN, this.handleTransitionIn);
        this.registerGame(ScatterPickEvent.PICK_RESPONSE, this.handlePickResponse);
        this.registerGame(ScatterPickEvent.PICK_RESULT, this.hideOverlay);
        this.registerGame(ScatterPickEvent.BACKGROUND_OUT, this.playBackgroundOut);
        this.registerGame(ScatterPickEvent.COCONUT_FLASH, this.handleCoconutFlash);
    }
    async handleTransitionIn() {
        this.visible = true;
        this.titleSpine.visible = false;
        this.instructionsText.visible = false;
        this.showOverlay();
        await this.playBackgroundIn();
        this.playTitleIn();
        this.playInstructionsIn();
    }
    async playBackgroundIn() {
        SpineUtil.playLoop(this.backgroundSpine, "loop");
        this.backgroundSpine.setSpeed(this.uiProperties.minSpeed);
        this.backgroundSpine.alpha = 0;
        await gsap.to(this.backgroundSpine, { alpha: 1, duration: this.uiProperties.fadeInDuration });
    }
    async playBackgroundOut() {
        await gsap.to(this.backgroundSpine, { alpha: 0, duration: this.uiProperties.fadeOutDuration });
        this.visible = false;
    }
    async playTitleIn() {
        this.titleSpine.visible = true;
        await new Promise(resolve => SpineUtil.play(this.titleSpine, "intro", resolve));
        SpineUtil.playLoop(this.titleSpine, "loop");
    }
    async playTitleOut() {
        await new Promise(resolve => SpineUtil.play(this.titleSpine, "out", resolve));
    }
    handleCoconutFlash() {
        this.titleSpine.visible = false;
        this.instructionsText.visible = false;
    }
    async playInstructionsIn() {
        this.instructionsText.visible = true;
        this.instructionsText.alpha = 0;
        this.instructionsText.scale.set(0.8);
        await gsap.to(this.instructionsText, {
            pixi: {
                alpha: 1,
                scale: 1,
            },
            duration: 1,
        });
    }
    playInstructionsOut() {
        gsap.to(this.instructionsText, {
            pixi: {
                alpha: 0,
                scale: 0.8,
            },
            duration: 1,
        });
    }
    async handlePickResponse() {
        const speed = GameMathUtil.lerp(this.uiProperties.minSpeed, this.uiProperties.maxSpeed, this.model.getPickTaps() / this.model.getPickTapsRequired());
        this.backgroundSpine.setSpeed(speed);
        if (this.model.getPickTaps() === this.model.getPickTapsRequired()) {
            this.playTitleOut();
            this.playInstructionsOut();
        }
    }
    showOverlay() {
        this.addChildAt(this.mouseBlocker, 0);
        this.mouseBlocker.alpha = 0;
        gsap.to(this.mouseBlocker, {
            alpha: 1,
            duration: TweenConstants.DEFAULT_OVERLAY_FADE_DURATION,
        });
    }
    hideOverlay() {
        gsap.to(this.mouseBlocker, {
            alpha: 0,
            duration: TweenConstants.DEFAULT_OVERLAY_FADE_DURATION,
            onComplete: () => this.removeChild(this.mouseBlocker),
        });
    }
    updateTransform() {
        // As the scatter pick sequence almost constantly resizes and shakes, we need to continually fit the mouse blocker to the window.
        this.mouseBlocker.fitToWindow();
        super.updateTransform();
    }
}
//# sourceMappingURL=GameScatterPickBackground.js.map